module.exports = __webpack_public_path__ + "static/media/normal.4edfd750.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/emojis/normal.gif
// module id = 169
// module chunks = 0